const REGEX = Object.freeze({
  // Matches Iranian mobile numbers: 09123456789
  PHONE_NUMBER: /^09\d{9}$/,

  // Matches Persian names with spaces: علی رضا، محمد
  PERSIAN_NAME: /^[\u0600-\u06FF\u200C\s]+$/,

  // Matches strings containing only whitespace: "   ", "\n\t"
  WHITESPACE: /^\s*$/,

  // Matches valid email addresses: user@example.com, john.doe@company.co.uk
  EMAIL: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/,

  // Matches Persian digits: ۰۱۲۳۴۵۶۷۸۹
  MATCH_PERSIAN_DIGITS: /[۰-۹]/g,

  // Matches Arabic digits: ٠١٢٣٤٥٦٧٨٩
  MATCH_ARABIC_DIGITS: /[٠-٩]/g,

  // Tests if a string contains ONLY numbers and nothing else
  ONLY_NUMBER: /^\d+$/,
  // Matches any non-digit character
  NOT_DIGIT: /\D/g,

  // Matches Arabic numerals: ٠١٢٣٤٥٦٧٨٩
  MATCH_ARABIC_RANGE: /[٠١٢٣٤٥٦٧٨٩]/g,

  // Matches Persian numerals: ۰۱۲۳۴۵۶۷۸۹
  MATCH_PERSIAN_RANGE: /[۰۱۲۳۴۵۶۷۸۹]/g,

  // Adds thousands separator: 1000 -> 1,000
  THOUSANDS_SEPARATOR: /\B(?=(\d{3})+(?!\d))/g,

  // Matches comma character
  COMMA: /,/g,

  // Matches newline character
  NEW_LINE: /\n/g,

  // Matches strings containing only letters, numbers, @ and .: abc123@.
  ONLY_CHARACTER: /^[a-zA-Z0-9@.]+$/,

  // Splits string every 4 characters (for card numbers): 1234567812345678 -> 1234 5678 1234 5678
  FORMAT_CARD_NUMBER: /.{1,4}/g,

  // Adds space between letters and numbers: abc123 -> abc 123, علی۱۲۳ -> علی ۱۲۳
  ADD_SPACE_BETWEEN_CHARACTERS_AND_NUMBERS: /([a-zA-Z\u0600-\u06FF])(\d)/g,

  // Adds space between numbers and letters: 123abc -> 123 abc, ۱۲۳علی -> ۱۲۳ علی
  ADD_SPACE_BETWEEN_NUMBERS_AND_CHARACTERS: /(\d)([^\d\s,.])/g,

  // Adds space between Persian/Arabic and Latin characters: کدتخفیفBUDYSH -> کدتخفیف BUDYSH
  ADD_SPACE_BETWEEN_PERSIAN_AND_LATIN: /([؀-ۿ])([A-Za-z])/g,

  // Adds space between Latin and Persian/Arabic characters: BUDYSHکدتخفیف -> BUDYSH کدتخفیف
  ADD_SPACE_BETWEEN_LATIN_AND_PERSIAN: /([A-Za-z])([؀-ۿ])/g,

  // Removes http:// or https:// and www. from URLs
  URL_WITHOUT_PROTOCOL: /^(?:https?:\/\/)?(?:www\.)?/,
});

export default REGEX;
